"use client";

import React from "react";
import Image from "next/image";

export default function RichText({ content }: { content: any }) {
  if (!content || !content.root || !content.root.children) return null;

  return (
    <div className="rich-text-content">
      {content.root.children.map((node: any, i: number) => {
        return <RenderNode key={i} node={node} />;
      })}
    </div>
  );
}

function RenderNode({ node }: { node: any }) {
  if (!node) return null;

  switch (node.type) {
    case "paragraph":
      return (
        <p style={{ marginBottom: "1.5rem", lineHeight: 1.8, color: "var(--text-secondary)" }}>
          <RenderChildren node={node} />
        </p>
      );
    case "heading":
      const Tag = node.tag as any;
      return (
        <Tag style={{ fontWeight: 800, marginBottom: "1.2rem", marginTop: "2rem", color: "var(--text-primary)" }}>
          <RenderChildren node={node} />
        </Tag>
      );
    case "list":
      const ListTag = node.listType === "bullet" ? "ul" : "ol";
      return (
        <ListTag style={{ marginBottom: "1.5rem", paddingLeft: "1.5rem", color: "var(--text-secondary)" }}>
          <RenderChildren node={node} />
        </ListTag>
      );
    case "listitem":
      return (
        <li style={{ marginBottom: "0.5rem" }}>
          <RenderChildren node={node} />
        </li>
      );
    case "text":
      let text = node.text;
      if (node.format & 1) text = <strong key="b">{text}</strong>;
      if (node.format & 2) text = <em key="i">{text}</em>;
      if (node.format & 4) text = <s key="s">{text}</s>;
      if (node.format & 8) text = <u key="u">{text}</u>;
      return <>{text}</>;
    case "link":
      return (
        <a href={node.fields?.url} target={node.fields?.newTab ? "_blank" : undefined} style={{ color: "var(--color-pink)", textDecoration: "underline" }}>
          <RenderChildren node={node} />
        </a>
      );
    case "upload":
      const media = node.value;
      if (!media || !media.url) return null;
      return (
        <div style={{ margin: "2rem 0", borderRadius: "1rem", overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
          <Image 
            src={media.url} 
            alt={media.alt || "Qumrah Content Media"} 
            width={media.width || 800} 
            height={media.height || 600}
            layout="responsive"
            style={{ objectFit: "cover" }}
          />
        </div>
      );
    default:
      if (node.children) return <RenderChildren node={node} />;
      return null;
  }
}

function RenderChildren({ node }: { node: any }) {
  if (!node.children) return null;
  return (
    <>
      {node.children.map((child: any, i: number) => (
        <RenderNode key={i} node={child} />
      ))}
    </>
  );
}
